import { Component } from 'preact';
import PropTypes from 'prop-types';
import Item from './Item';
import ItemPlaceholder from './ItemPlaceholder';

class ListFiatV2 extends Component {
  componentDidMount() {
    window.matchHeight.match('.list-vehicles-new__list');
  }

  componentDidUpdate() {
    window.matchHeight.match('.list-vehicles-new__list');
  }

  render() {
    const { items, part_link, loading, loadingMore, abarthScorpionIcon } =
      this.props;

    return (
      <div className="list-vehicles-new__list">
        <div className="row">
          {items.map(item => (
            <div
              className="col-6 col-md-4 col-lg-3 mb-4"
              aria-label={`Card do veículo ${item.title}`}
            >
              {loading && !loadingMore ? (
                <ItemPlaceholder />
              ) : (
                <Item
                  image={
                    item.side_profile_image ||
                    (item.item_image && item.item_image.middle_image)
                  }
                  title={item.title}
                  part_link={part_link}
                  slug={item.slug}
                  width={item.side_profile_image ? 236 : 176}
                  height={item.side_profile_image ? 105 : 123.63}
                  customClasses={
                    item.side_profile_image
                      ? 'new-vehicle-card__side-profile-image'
                      : ''
                  }
                  abarthScorpionIcon={abarthScorpionIcon}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

ListFiatV2.defaultProps = {
  items: [],
  showLoadMore: false,
  loading: false,
  loadingMore: false,
  onClickButtonLoadMore() {},
  abarthScorpionIcon: '',
};

ListFiatV2.propTypes = {
  items: PropTypes.arrayOf,
  loadingMore: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  showLoadMore: PropTypes.bool,
  loading: PropTypes.bool,
  part_link: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  onClickButtonLoadMore: PropTypes.func,
  abarthScorpionIcon: PropTypes.string,
};

export default ListFiatV2;
